import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../contexts/AuthCtx";

export default function SignedGuard({ children }) {
  const authCtx = useAuth();
  const navigateTo = useNavigate();
  const location = useLocation();

  const [page, setPage] = useState("loading");

  useEffect(() => {
    if (authCtx.initialized) {
      if (authCtx.authenciated !== null && authCtx.authenciated === false) {
        navigateTo('/');
        setPage("login");
      } else {
        if (authCtx.authenciated && authCtx.user) {
          setPage("app");
        }
      }
    }
  }, [authCtx.initialized, authCtx.authenciated]);

  if (page === "loading") {
    return <h1>Loading...</h1>;
  } else if (page === "app") {
    return children;
  }
}
